import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

@Injectable()
export class OnboardingService {

    constructor(private http: HttpClient) {}
    
    async checkUserToken(token: string): Promise<void> {
        await firstValueFrom(this.http.get('/signup/' + token));
    }

    async registerUser(data: string, token: string): Promise<any> {
        return await firstValueFrom(this.http.post(`/signup/${token}`, data,  {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'} // set the headers so angular passing info as form data (not request payload)
        }));
    }
}